import './faq.scss';

(function() {
  const triggers = document.querySelectorAll('.faq__trigger');
  const bodies = document.querySelectorAll('.faq__body');
  let open = null;

  triggers.forEach((trigger, id) => {
    trigger.addEventListener('click', event => {
      event.preventDefault();

      if (open === id) {
        bodies[id].style.maxHeight = 0;
        open = null;
      }
      else {
        bodies.forEach(body => {
          body.style.maxHeight = 0;
        });

        bodies[id].style.maxHeight = bodies[id].scrollHeight + 'px';
        open = id;
      }
    });
  });
})();